<template>
  <b-row class="filters-row">
    <b-col cols="3">
      <div class="form-label">
        Search matches
      </div>
      <base-autocomplete
        id="search-matches"
        data-test="campaign-name-search-input"
        size="sm"
        :items="items"
        :display-property="searchDisplayProperty"
        v-model="searchText"
        :search-text.sync="searchText"
        @change="updateAssociationWithSearch"
        @keyup.native="updateAssociationWithSearch"
      />
    </b-col>
    <b-col cols="6">
      <div class="form-label">
        Filters
      </div>
      <b-row>
        <b-col cols="4">
          <base-filter-dropdown
            class="w-100 custom-height-dropdown"
            :filter="'publisher'"
            :options-list="filterOptions.publisher.options"
            :key-property="'id'"
            :value-property="'value'"
            :selected-options="filterOptions.publisher.search"
            @updatedSelectedOptions="updateAssociationWithFilter('publisher', ...arguments)"
            @selectAllOptions="selectAllOptions('publisher')"
            @deselectAllOptions="deselectAllOptions('publisher')"
          />
        </b-col>
        <b-col cols="4">
          <base-filter-dropdown
            class="w-100 custom-height-dropdown"
            :filter="'advertiser content'"
            :options-list="filterOptions.advertiser.options"
            :key-property="'id'"
            :value-property="'value'"
            :selected-options="filterOptions.advertiser.search"
            @updatedSelectedOptions="updateAssociationWithFilter('advertiser', ...arguments)"
            @selectAllOptions="selectAllOptions('advertiser')"
            @deselectAllOptions="deselectAllOptions('advertiser')"
          />
        </b-col>
        <b-col cols="4">
          <base-filter-dropdown
            class="w-100 custom-height-dropdown"
            :filter="'creative size'"
            :options-list="filterOptions.creative.options"
            :key-property="'id'"
            :value-property="'value'"
            :selected-options="filterOptions.creative.search"
            @updatedSelectedOptions="updateAssociationWithFilter('creative', ...arguments)"
            @selectAllOptions="selectAllOptions('creative')"
            @deselectAllOptions="deselectAllOptions('creative')"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col
      cols="3"
      class="text-right"
    >
      <b-button
        variant="primary"
        size="md"
        @click="$emit('exportCsvFile')"
        :disabled="isCsvButtonDisabled"
      >
        Download {{ this.isCsvButtonDisabled ? '' : this.selectedItems.length }} Selected As CSV
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import BaseAutocomplete from '@/components/form/BaseAutocomplete.vue';
import BaseFilterDropdown from '@/components/BaseFilterDropdown.vue';

export default {
  name: 'CampaignMatchesFilters',
  components: {
    BaseFilterDropdown,
    BaseAutocomplete,
  },
  props: {
    selectedItems: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.generateOptions('publisher');
    this.generateOptions('advertiser');
    this.generateOptions('creative');
  },
  computed: {
    isCsvButtonDisabled() {
      return this.selectedItems.length < 1;
    },
  },
  data() {
    return {
      searchText: '',
      searchDisplayProperty: 'publisherHeadline',
      filterOptions: {
        advertiser: {
          search: [],
          options: [],
          itemFieldName: 'advertiserContent',
        },
        publisher: {
          search: [],
          options: [],
          itemFieldName: 'publisherName',
        },
        creative: {
          search: [],
          options: [],
          itemFieldName: 'creativeSize',
        },
      },
    };
  },
  methods: {
    emitFilterItems(optionsForFilter) {
      this.$emit('filterItems', {
        search: optionsForFilter.search,
        itemFieldName: optionsForFilter.itemFieldName,
        reset: true,
      });
    },
    generateOptions(filterName) {
      const optionsForFilter = this.filterOptions[filterName];
      const uniqueValues = [...new Set(this.items.map((item) => item[optionsForFilter.itemFieldName]))];
      this.filterOptions[filterName].options = uniqueValues.map((name) => ({ id: name, value: name }));
      this.selectAllOptions(filterName);
    },
    resetItems() {
      this.$emit('resetItems', {
        filterOptions: this.filterOptions,
        searchText: this.searchText,
      });
    },
    selectAllOptions(filterName) {
      this.filterOptions[filterName].search = this.filterOptions[filterName].options.map((option) => option.id);
      this.resetItems();
    },
    deselectAllOptions(filterName) {
      this.filterOptions[filterName].search = [];
      this.resetItems();
    },
    updateAssociationWithSearch() {
      this.resetItems();
      if (this.searchText) {
        this.$emit('searchItems', this.searchText);
      }
    },
    updateAssociationWithFilter(filterName, id, isChecked) {
      this.resetItems();
      if (isChecked) {
        this.filterOptions[filterName].search.push(id);
        this.resetItems();
      } else {
        const index = this.filterOptions[filterName].search.indexOf(id);
        this.filterOptions[filterName].search.splice(index, 1);
        this.emitFilterItems(this.filterOptions[filterName]);
      }
    },
  },
};
</script>
